import api           from '../../../../configs/api'
import Form          from '../../../../display/forms/FormElements'
import Organization  from '../../../../things/Organization'
import PropertyValue from '../../../../things/PropertyValue'
import Thing         from '../../../../things/Thing'

const memberOf =
{
    add :
    {
        agree       : 'Ajouter' ,
        disagree    : 'Annuler' ,
        description : 'Veuillez sélectionner une organisation parente en cliquant ci-dessous.' ,
        elements    :
        [
            {
                type       : Form.SEARCH_SELECTOR ,
                path       : api.organizations.url ,
                clazz      : Organization,
                clearLabel : 'Vider' ,
                closeLabel : 'Fermer' ,
                init       :
                {
                    id         : 'value',
                    key        : 'value',
                    label      : 'Organisation',
                    autoFocus  : false,
                    fullWidth  : true,
                    margin     : 'normal',
                    required   : true,
                    type       : 'search'
                },
                inputProps :
                {
                    label : 'Organisation...'
                },
                logics :
                {
                    disabledSuggestions : ( props ) =>
                    {
                        const { rel } = props ;
                        let suggestions = [] ;
                        if( rel instanceof Thing )
                        {
                            const { subjectOf } = rel ;
                            if( subjectOf instanceof Thing )
                            {
                                if( subjectOf instanceof Organization )
                                {
                                    suggestions.push( subjectOf ) ;
                                }
                                const { memberOf } = subjectOf ;
                                if( memberOf instanceof Array )
                                {
                                    suggestions.push( ...memberOf ) ;
                                }
                            }
                        }
                        return suggestions ;
                    }
                }
            }
        ],
        fail    : 'Veuillez corriger les erreurs ci-dessous!' ,
        loading : 'Chargement en  cours...' ,
        prepare : () => null ,
        mapUri  : ( item , uri ) =>
        {
            if( item instanceof PropertyValue)
            {
                const { value } = item ;
                if( value instanceof Thing )
                {
                    return uri + '/' + value.id ;
                }
            }
            return uri ;
        },
        success : 'Ajout d\'une nouvelle organisation réussi!' ,
        title   : 'Ajouter une organisation'
    },
    remove :
    {
        agree       : 'Supprimer' ,
        description : 'Souhaitez-vous supprimer cette organisation parente:' ,
        disagree    : 'Annuler' ,
        loading     : 'Suppression en cours...' ,
        title       : 'Supprimer l\'organisation ?'
    },
    title : 'Membre des organisations' ,
    tooltips :
    {
        add    : "Ajouter" ,
        edit   : "Éditer" ,
        remove : "Supprimer"
    }
};

export default memberOf ;
